const IncidentKeys = {
    UpdateWorkCompIncidentPostKeys: [
        "WorkersCompensationIncidentId",
        "EmployeeId",
        "IncidentTypeId",
        "IncidentDateUTC",
        "IncidentStateId",
        "IncidentStatusId",
        "ClaimNumber",
        "FullDutyReleaseDateUTC",
        "DaysOffWork",
        "DaysLightDuty",
        "IncidentDescription",
        "Restrictions",
        "RestrictionsDescription",
        "MedicalTreatment",
        "OshaRecordable",
        "DeletedDateUTC",
        "DisabledDateUTC"]
}
export default IncidentKeys